import core from './core.instance';

export const DACore = core;